import React, { Component } from 'react';

class TemplateElement extends Component {
    constructor(props) {
        super(props);
        this.elementRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.onMount && this.props.elementId) {
            this.props.onMount(this.props.elementId, this.elementRef.current);
        }
    }

    componentWillUnmount() {
        if (this.props.onUnmount && this.props.elementId) {
            this.props.onUnmount(this.props.elementId);
        }
    }

    render() {
        const { element, style, isSelected, onClick, dataAttributes } = this.props;

        const isCompanyProp = element.section === "head" &&
            element.name &&
            element.name.includes("EPOSCompanyDefinition");

        const dataPath = isCompanyProp ? "companyProps" : "elements";
        const dataIndex = element.name ? element.name.replace(/\./g, "") : "";

        const isList = style.listStyleType && style.listStyleType !== 'none';
        const textLines = element.text ? element.text.split('\n') : [''];

        return (
            <div
                ref={this.elementRef}
                onClick={onClick}
                style={style}
                id={element.id}
                data-element={element.name}
                data-section={element.section}
                data-path={dataPath}
                data-index={dataIndex}
                {...dataAttributes}
                className={"custom-element" + (isSelected ? " selected-element" : "")}
            >
                {isList ? (
                    <ul style={{
                        margin: 0,
                        padding: 0,
                        paddingLeft: style.listStyleType === 'decimal' ? '25px' : '20px',
                        listStyleType: style.listStyleType
                    }}>
                        {textLines.map((line, idx) => (
                            <li key={idx} style={{
                                color: style.color,
                                fontSize: style.fontSize,
                                fontFamily: style.fontFamily,
                                fontWeight: style.fontWeight,
                                fontStyle: style.fontStyle,
                                textDecoration: style.textDecoration,
                                textAlign: style.textAlign,
                                marginBottom: idx < textLines.length - 1 ? '4px' : '0'
                            }}>
                                {line || '\u00A0'}
                            </li>
                        ))}
                    </ul>
                ) : (
                    element.text
                )}
                {isSelected ? this.props.renderElementControl?.() : <></>}
            </div>
        );
    }
}

export default TemplateElement;